// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ProviderClaimTransmission,
    ProviderTransmissionSortType,
    SupportClaimTransmission,
    SupportCreateDentalTransmissionPayload,
    SupportCreateInstitutionalTransmissionPayload,
    SupportCreateProfessionalTransmissionPayload,
    SupportTransmissionSortType,
    SupportCreateDentalTransmissionPayloadToJSON,
    SupportCreateInstitutionalTransmissionPayloadToJSON,
    SupportCreateProfessionalTransmissionPayloadToJSON,
    ProviderClaimTransmissionFromJSON,
    SupportClaimTransmissionFromJSON,
} from '../models';

export interface CreateSupportDentalTransmissionRequest {
    id: string;
    supportCreateDentalTransmissionPayload: SupportCreateDentalTransmissionPayload;
}

export interface CreateSupportInstitutionalTransmissionRequest {
    id: string;
    supportCreateInstitutionalTransmissionPayload: SupportCreateInstitutionalTransmissionPayload;
}

export interface CreateSupportProfessionalTransmissionRequest {
    id: string;
    supportCreateProfessionalTransmissionPayload: SupportCreateProfessionalTransmissionPayload;
}

export interface GetProviderClaimTransmissionRequest {
    id: string;
}

export interface GetSupportClaimTransmissionRequest {
    id: string;
}

export interface ListProviderClaimTransmissionsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderClaimTransmissionsOrderEnum>;
    filterCreated?: Array<string>;
    filterExternalId?: Array<string>;
    filterClaimId?: Array<string>;
    filterProfessionalId?: Array<string>;
    filterInstitutionalId?: Array<string>;
    filterDentalId?: Array<string>;
    filterNynf3Id?: Array<string>;
    sort?: Array<ProviderTransmissionSortType>;
}

export interface ListSupportClaimTransmissionsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportClaimTransmissionsOrderEnum>;
    filterCreated?: Array<string>;
    filterExternalId?: Array<string>;
    filterClaimId?: Array<string>;
    filterProfessionalId?: Array<string>;
    filterInstitutionalId?: Array<string>;
    filterDentalId?: Array<string>;
    filterNynf3Id?: Array<string>;
    filterClearinghousePayerId?: Array<string>;
    sort?: Array<SupportTransmissionSortType>;
}

/**
 * no description
 */
export class TransmissionApi extends runtime.BaseAPI {

    /**
     * Create an electronic dental claim transmission
     * Create an electronic dental claim transmission
     */
    async createSupportDentalTransmissionRaw(requestParameters: CreateSupportDentalTransmissionRequest): Promise<runtime.ApiResponse<SupportClaimTransmission>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportDentalTransmission.');
        }

        if (requestParameters['supportCreateDentalTransmissionPayload'] === null || requestParameters['supportCreateDentalTransmissionPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDentalTransmissionPayload','Required parameter requestParameters.supportCreateDentalTransmissionPayload was null or undefined when calling createSupportDentalTransmission.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:transmission", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/transmission/dental/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDentalTransmissionPayloadToJSON(requestParameters['supportCreateDentalTransmissionPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimTransmissionFromJSON(jsonValue));
    }

    /**
     * Create an electronic dental claim transmission
     * Create an electronic dental claim transmission
     */
    async createSupportDentalTransmission(requestParameters: CreateSupportDentalTransmissionRequest): Promise<SupportClaimTransmission> {
        const response = await this.createSupportDentalTransmissionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an electronic institutional claim transmission
     * Create an electronic institutional claim transmission
     */
    async createSupportInstitutionalTransmissionRaw(requestParameters: CreateSupportInstitutionalTransmissionRequest): Promise<runtime.ApiResponse<SupportClaimTransmission>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportInstitutionalTransmission.');
        }

        if (requestParameters['supportCreateInstitutionalTransmissionPayload'] === null || requestParameters['supportCreateInstitutionalTransmissionPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateInstitutionalTransmissionPayload','Required parameter requestParameters.supportCreateInstitutionalTransmissionPayload was null or undefined when calling createSupportInstitutionalTransmission.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:transmission", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/transmission/institutional/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateInstitutionalTransmissionPayloadToJSON(requestParameters['supportCreateInstitutionalTransmissionPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimTransmissionFromJSON(jsonValue));
    }

    /**
     * Create an electronic institutional claim transmission
     * Create an electronic institutional claim transmission
     */
    async createSupportInstitutionalTransmission(requestParameters: CreateSupportInstitutionalTransmissionRequest): Promise<SupportClaimTransmission> {
        const response = await this.createSupportInstitutionalTransmissionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an electronic professional claim transmission
     * Create an electronic professional claim transmission
     */
    async createSupportProfessionalTransmissionRaw(requestParameters: CreateSupportProfessionalTransmissionRequest): Promise<runtime.ApiResponse<SupportClaimTransmission>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportProfessionalTransmission.');
        }

        if (requestParameters['supportCreateProfessionalTransmissionPayload'] === null || requestParameters['supportCreateProfessionalTransmissionPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateProfessionalTransmissionPayload','Required parameter requestParameters.supportCreateProfessionalTransmissionPayload was null or undefined when calling createSupportProfessionalTransmission.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:transmission", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/transmission/professional/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateProfessionalTransmissionPayloadToJSON(requestParameters['supportCreateProfessionalTransmissionPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimTransmissionFromJSON(jsonValue));
    }

    /**
     * Create an electronic professional claim transmission
     * Create an electronic professional claim transmission
     */
    async createSupportProfessionalTransmission(requestParameters: CreateSupportProfessionalTransmissionRequest): Promise<SupportClaimTransmission> {
        const response = await this.createSupportProfessionalTransmissionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a claim transmission
     * Retrieve a claim transmission to a payer
     */
    async getProviderClaimTransmissionRaw(requestParameters: GetProviderClaimTransmissionRequest): Promise<runtime.ApiResponse<ProviderClaimTransmission>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderClaimTransmission.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:transmission"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/transmission/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderClaimTransmissionFromJSON(jsonValue));
    }

    /**
     * Get a claim transmission
     * Retrieve a claim transmission to a payer
     */
    async getProviderClaimTransmission(requestParameters: GetProviderClaimTransmissionRequest): Promise<ProviderClaimTransmission> {
        const response = await this.getProviderClaimTransmissionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a claim transmission
     * Retrieve a claim transmission to a payer
     */
    async getSupportClaimTransmissionRaw(requestParameters: GetSupportClaimTransmissionRequest): Promise<runtime.ApiResponse<SupportClaimTransmission>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportClaimTransmission.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:transmission", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/transmission/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimTransmissionFromJSON(jsonValue));
    }

    /**
     * Get a claim transmission
     * Retrieve a claim transmission to a payer
     */
    async getSupportClaimTransmission(requestParameters: GetSupportClaimTransmissionRequest): Promise<SupportClaimTransmission> {
        const response = await this.getSupportClaimTransmissionRaw(requestParameters);
        return await response.value();
    }

    /**
     * List claim transmissions
     * List claim transmissions
     */
    async listProviderClaimTransmissionsRaw(requestParameters: ListProviderClaimTransmissionsRequest): Promise<runtime.ApiResponse<Array<ProviderClaimTransmission>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterExternalId) {
            queryParameters['filterExternalId'] = requestParameters.filterExternalId;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterProfessionalId) {
            queryParameters['filterProfessionalId'] = requestParameters.filterProfessionalId;
        }

        if (requestParameters.filterInstitutionalId) {
            queryParameters['filterInstitutionalId'] = requestParameters.filterInstitutionalId;
        }

        if (requestParameters.filterDentalId) {
            queryParameters['filterDentalId'] = requestParameters.filterDentalId;
        }

        if (requestParameters.filterNynf3Id) {
            queryParameters['filterNynf3Id'] = requestParameters.filterNynf3Id;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:transmission"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/transmission`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderClaimTransmissionFromJSON));
    }

    /**
     * List claim transmissions
     * List claim transmissions
     */
    async listProviderClaimTransmissions(requestParameters: ListProviderClaimTransmissionsRequest): Promise<Array<ProviderClaimTransmission>> {
        const response = await this.listProviderClaimTransmissionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * List claim transmissions
     * List claim transmissions
     */
    async listSupportClaimTransmissionsRaw(requestParameters: ListSupportClaimTransmissionsRequest): Promise<runtime.ApiResponse<Array<SupportClaimTransmission>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterExternalId) {
            queryParameters['filterExternalId'] = requestParameters.filterExternalId;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterProfessionalId) {
            queryParameters['filterProfessionalId'] = requestParameters.filterProfessionalId;
        }

        if (requestParameters.filterInstitutionalId) {
            queryParameters['filterInstitutionalId'] = requestParameters.filterInstitutionalId;
        }

        if (requestParameters.filterDentalId) {
            queryParameters['filterDentalId'] = requestParameters.filterDentalId;
        }

        if (requestParameters.filterNynf3Id) {
            queryParameters['filterNynf3Id'] = requestParameters.filterNynf3Id;
        }

        if (requestParameters.filterClearinghousePayerId) {
            queryParameters['filterClearinghousePayerId'] = requestParameters.filterClearinghousePayerId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:transmission", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/transmission`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportClaimTransmissionFromJSON));
    }

    /**
     * List claim transmissions
     * List claim transmissions
     */
    async listSupportClaimTransmissions(requestParameters: ListSupportClaimTransmissionsRequest): Promise<Array<SupportClaimTransmission>> {
        const response = await this.listSupportClaimTransmissionsRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderClaimTransmissionsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportClaimTransmissionsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
